import {GetBeneficiaryAddressSuggestionV4Response} from 'domain/usecases';
import {makeGetBeneficiaryAddressSuggestionV4} from 'main/factories/usecases';

type GetAddressSuggestionParams = {
	signal?: AbortSignal;
};

export async function getAddressSuggestion({
	signal,
}: GetAddressSuggestionParams): Promise<GetBeneficiaryAddressSuggestionV4Response> {
	return makeGetBeneficiaryAddressSuggestionV4().get({acceptedFlag: 'P', signal});
}
